import React, { useEffect, useState } from "react";
import { useRecording } from "../../context/RecordingContext";
import {
  VOICE_REASON, readRecord, reviewStoreKey, voiceChecked, voiceRemove, voiceRestore, voiceRowsFor, voiceSetChecked, writeRecord,
} from "./orderReviewModel";

/* "Ordered by voice" (owner decision 2026-10-22; BlinkScribe order_suggest_v2/voice.py).

   Shown in the chart's live LiveScribe panel while the recording runs, for providers with the end-of-visit
   Order Review (BlinkScribe: the same users, its own kill switch). Every order the provider SAID as an order
   ("order a CBC", "let's get an echo") is listed ticked within a section of being said. The provider can
   untick a row (it stays on the review screen, unchecked) or remove it (not offered at all). Nothing is placed
   here: the rows reach the end-of-visit Order Review pre-checked (BlinkScribe merges them into the payload) and
   only its Confirm places them, through the same add as every other review row.

   The choices live in the visit's review record (orderReviewModel: checks / voiceRemoved), so the review screen
   opens with them. Ids, concept ids, catalogue order names and the provider's own short quote only. */

const box = {
  margin: "6px 0 8px", padding: "8px 10px", border: "1px solid #C7D2FE", borderRadius: 8, background: "#EEF2FF",
};
const title = { display: "flex", alignItems: "center", gap: 6, fontSize: 11, fontWeight: 700, color: "#3730A3", marginBottom: 4 };
const rowS = { display: "flex", alignItems: "flex-start", gap: 6, padding: "3px 0", fontSize: 12, color: "#1F2937" };
const quoteS = { fontSize: 10, color: "#6B7280", fontStyle: "italic", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
const xBtn = {
  marginLeft: "auto", border: "none", background: "none", color: "#6B7280", cursor: "pointer", fontSize: 12, lineHeight: 1, padding: "0 2px",
};

const VoiceOrdersPanel = ({ patientId }) => {
  const { voiceOrders } = useRecording();
  const vo = voiceOrders || null;
  const pid = vo && vo.patientid != null ? String(vo.patientid) : "";
  const appt = vo && vo.appointmentid != null ? String(vo.appointmentid) : "";
  const rows = voiceRowsFor(vo, patientId, appt || null);
  const storeKey = pid && appt ? reviewStoreKey(pid, appt) : null;
  const [rec, setRec] = useState(() => (storeKey ? readRecord(storeKey) : null));

  useEffect(() => {
    setRec(storeKey ? readRecord(storeKey) : null);
  }, [storeKey]);

  if (!rows.length || !storeKey) return null;

  const save = (next) => {
    writeRecord(storeKey, next);
    setRec(next);
  };
  const removed = (rec && rec.voiceRemoved) || {};
  const shown = rows.filter((r) => !removed[r.concept]);
  const hidden = rows.filter((r) => removed[r.concept]);

  return (
    <div style={box} data-testid="voice-orders-panel">
      <div style={title}>
        <span aria-hidden="true">🗣</span> {VOICE_REASON}
        <span style={{ marginLeft: "auto", fontWeight: 500, color: "#6B7280" }}>placed only on Confirm</span>
      </div>
      {shown.map((r) => {
        const on = voiceChecked(rec, r.concept);
        return (
          <div key={r.concept} style={rowS} data-concept={r.concept}>
            <input
              type="checkbox"
              checked={on}
              aria-label={`Order ${r.order_name}`}
              onChange={(e) => save(voiceSetChecked(rec, r.concept, e.target.checked))}
              style={{ marginTop: 2 }}
            />
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ fontWeight: 600, opacity: on ? 1 : 0.55 }}>{r.order_name}</div>
              {r.quote ? <div style={quoteS} title={r.quote}>“{r.quote}”</div> : null}
            </div>
            <button type="button" style={xBtn} aria-label={`Remove ${r.order_name}`} title="Remove" onClick={() => save(voiceRemove(rec, r.concept))}>
              ✕
            </button>
          </div>
        );
      })}
      {hidden.length ? (
        <div style={{ fontSize: 10, color: "#6B7280", marginTop: 2 }}>
          Removed:{" "}
          {hidden.map((r, i) => (
            <span key={r.concept}>
              {i ? ", " : ""}
              <button
                type="button"
                style={{ ...xBtn, marginLeft: 0, textDecoration: "underline", fontSize: 10 }}
                aria-label={`Restore ${r.order_name}`}
                onClick={() => save(voiceRestore(rec, r.concept))}
              >
                {r.order_name}
              </button>
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default VoiceOrdersPanel;
